export const getMinutesWithLeadingZero = (minutes: number) => (minutes < 10 ? `${0}${minutes}` : minutes);
